import React from 'react';
import Icon from './Icon';

export default Icon(
  <polygon points="0,3 12,3 6,9 0,3 " />, '0 0 12 12', 'DownIcon',
);
